import { Button } from "@arco-design/web-react";
import { useRailwayQuery } from "../runtime";
import { resolveStation } from "../service";
import type { RailwayFareSelection } from "../types";
import { RailwaySearchBar } from "./QueryControls";
import { RailwayQueryResults } from "./RailwayQueryResults";
import "./railwayQuery.css";

/** 核价抽屉内的铁路查询。多选票价后由外层写入明细，不依赖路由。 */
export function RailwayQueryEmbed({ search, onApply }: { search: string; onApply: (fares: RailwayFareSelection[]) => void }) {
  const r = useRailwayQuery(search);
  const outboundFrom = resolveStation(r.submittedDraft.from, r.metadata?.stations ?? [])?.name ?? r.submittedDraft.from;
  const outboundTo = resolveStation(r.submittedDraft.to, r.metadata?.stations ?? [])?.name ?? r.submittedDraft.to;
  return <main className="railway-query-page railway-query-full">
    <div className="railway-query-scroll"><div className="railway-query-content">
      <RailwaySearchBar runtime={r} />
      {r.validationError && <p className="rail-validation" role="alert">{r.validationError}</p>}
    </div></div>
    <RailwayQueryResults runtime={r} directions={r.submittedDraft.roundTrip && <div className="rail-legs" role="group" aria-label="往返方向"><button type="button" className={r.leg === "outbound" ? "active" : ""} onClick={() => r.selectLeg("outbound")}>去程：{outboundFrom} → {outboundTo}</button><button type="button" className={r.leg === "return" ? "active" : ""} onClick={() => r.selectLeg("return")}>返程：{outboundTo} → {outboundFrom}</button></div>} />
    <div className="qb-rail-query-apply"><Button type="primary" disabled={r.selectedFares.length === 0} onClick={() => onApply(r.selectedFares)}>加入核价明细{r.selectedFares.length ? `（${r.selectedFares.length}）` : ""}</Button></div>
  </main>;
}
